import React, {Fragment} from 'react';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import ComponentField from "../../form/ComponentField";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter, optionsTemplate} from "../../../utils/formatters";
import Invoice from "../OperationList/Elements/Invoice";
import TextInput from "../../form/TextInput";
import {ifCompletedInput} from "../../../utils/other";
import Select from "../../form/Select";
import {componentFilter} from "../../../utils/filters";

const sortable = true;
const filterable = true;

class AcquisitionForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-1">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-md-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="customer"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label={<Fragment>&nbsp;</Fragment>}
                        />
                    </div>
                    <div className="col-md-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="seller"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Partner"
                        />
                    </div>
                    <div className="col-md-5">
                        <DateTimeInput
                            name="transaction_date"
                            value={this.props.values.transaction_date}
                            label="Beszerzés dátuma"
                            showTime={false}
                            {...this.props.getFieldProps("transaction_date")}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                {this.props.values[this.props.componentConfig.idfield] && <div className="row form-row">
                    <div className="col-md-12">
                        <SelectorGrid
                            {...this.props.getFieldProps("items")}
                            ref={(e) => this.items = e}
                            className={"p-small-table"}
                            exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                            onItemUpdate={true}
                            onLoadCompleted={(response) => {
                                if ((this.props.values.state || "0") === "0" && Object.keys(response).length) {
                                    response = {...response};
                                    response.rows = [...response.rows];
                                    response.rows.push({});
                                }
                                return response;
                            }}
                            columns={{
                                "name": {
                                    header: 'Megnevezés',
                                    width: 2,
                                    sortable,
                                    filterable,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput name="name" label={false} focus value={value}
                                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                },
                                "ledger": {
                                    header: "Beszerzés típusa",
                                    width: "ledger",
                                    renderer: (value) => <span className="ledger">{(value || {}).name}</span>,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <Select
                                                    name="ledger"
                                                    component="ledger"
                                                    objectValue={true}
                                                    label={false}
                                                    storeType="local"
                                                    value={value}
                                                    saveChanges={(field, value) => {
                                                        parent.onEditorValueChange(props, value);
                                                    }}
                                                />
                                },
                                "saleprice": {
                                    header: 'Bruttó egységár',
                                    width: 2,
                                    sortable,
                                    filterable,
                                    renderer: CurrencyFormatter,
                                    className: "currency",
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput type="decimal" name="saleprice" label={false} focus value={value}
                                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                },
                                "vat": {
                                    header: "Áfa",
                                    width: "vat",
                                    sortable,
                                    filterable: componentFilter({component: "vatrate"}),
                                    renderer: (value) => <span className="vat">{(value || {}).name}</span>,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <Select
                                                    name="vat"
                                                    component="vatrate"
                                                    filter={{field: "active", value: 1}}
                                                    objectValue={true}
                                                    label={false}
                                                    storeType="local"
                                                    value={value}
                                                    view={["rate"]}
                                                    saveChanges={(field, value) => {
                                                        parent.onEditorValueChange(props, value);
                                                    }}
                                                />
                                },
                                "qty": {
                                    header: "Darabszám",
                                    width: 2,
                                    sortable,
                                    filterable,
                                    className: "unit",
                                    renderer: (value) => <span className="unit">{value}</span>,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput type="decimal" name="qty" label={false} focus value={value}
                                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                },
                                "unit": {
                                    header: "Egység",
                                    width: 2,
                                    sortable,
                                    filterable,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput type="text" name="unit" label={false} focus value={value}
                                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                },
                                "location": {
                                    header: "Tárolási helység",
                                    width: "location",
                                    renderer: (value) => <span className="location">{(value || {}).name}</span>,
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <Select
                                                    name="location"
                                                    component="location"
                                                    objectValue={true}
                                                    label={false}
                                                    storeType="local"
                                                    optionsTemplate={optionsTemplate("location")}
                                                    filter={[{field: "partner", value: this.props.pos.partner.partner_id}]}
                                                    value={value}
                                                    saveChanges={(field, value) => {
                                                        parent.onEditorValueChange(props, value);
                                                    }}
                                                />
                                },
                            }}
                            name="items"
                            data={this.props.values}
                            orderBy={{field: "name", direction: "ASC"}}
                            componentConfig={this.props.componentConfig}
                        />
                    </div>
                </div>}
            </form>
        );
    }
}

export default createForm(AcquisitionForm);
